module.exports = __webpack_public_path__ + "img/banner5.ee332401.jpg";